
import { Vue, Component, Ref, Watch } from 'vue-property-decorator';
import AddVoucherModal from './components/AddVoucherModal.vue';
import EditVoucherModal from './components/EditVoucherModal.vue';
import CorrelationOrderDrawer from './components/CorrelationOrderDrawer.vue';
import VoucherService from '@/services/voucher.service';
import lazyInject from '@/di';
import moment, { Moment } from 'moment';
import CarService from '@/services/car.service';
import { AuthEnum } from '@/services/permission.service';

@Component({
  components: {
    AddVoucherModal,
    EditVoucherModal,
    CorrelationOrderDrawer,
  },
})
export default class CarPaymentVoucherManagement extends Vue {
  form: any = {
    flow_no: '',
    channel: '',
    resource_id: '',
    receive_payment_time: '',
    amount: '',
    payee: '',
    uploader: '',
    upload_start_time: '',
    upload_end_time: '',
    receipt_start_time: '',
    receipt_end_time: '',
  };

  AuthEnum = AuthEnum;

  @Ref('addVoucherModal')
  addVoucherModal!: AddVoucherModal;

  @Ref('editVoucherModal')
  editVoucherModal!: EditVoucherModal;

  @Ref('correlationOrderDrawer')
  correlationOrderDrawer!: CorrelationOrderDrawer;

  @lazyInject(VoucherService)
  voucherService!: VoucherService;

  @lazyInject(CarService)
  carService!: CarService;

  columns: any = [
    {
      title: '收款渠道',
      dataIndex: 'channel_str',
      key: 'channel_str',
      width: 80,
      align: 'center',
    },
    {
      title: '付款方',
      dataIndex: 'payee',
      key: 'payee',
      width: 100,
      align: 'center',
    },
    {
      title: '收款流水号',
      dataIndex: 'flow_no',
      key: 'flow_no',
      width: 100,
      align: 'center',
    },
    {
      title: '收款时间',
      dataIndex: 'receive_time',
      key: 'receive_time',
      width: 100,
      align: 'center',
    },
    {
      title: '收款凭证金额',
      dataIndex: 'amount',
      key: 'amount',
      width: 100,
      align: 'center',
    },
    {
      title: '上传人',
      dataIndex: 'uploader',
      key: 'uploader',
      align: 'center',
      width: 100,
    },
    {
      title: '上传时间',
      dataIndex: 'upload_time',
      key: 'upload_time',
      align: 'center',
      width: 100,
    },
    {
      title: '操作',
      key: 'action',
      scopedSlots: { customRender: 'action' },
      align: 'center',
      width: 100,
    },
  ];

  data: any = [];

  receiptTime: any = [];

  uploadTime: any = [];

  pagination = {
    total: 0,
    current: 1,
    pageSize: 10,
    onChange: this.onChangePage,
    showSizeChanger: true,
    showTotal: () => {
      return `共${this.pagination.total}条`;
    },
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    onShowSizeChange: this.onShowSizeChange,
  };

  @Watch('$route')
  handleSearch() {
    const { page, pageSize, flow_no, channel, payee, uploader, upload_start_time, upload_end_time, receipt_start_time, receipt_end_time } = this.$route.query;
    const query: any = {
      page: page || 1,
      pageSize: pageSize || 10,
      category: 2,
    };
    if (flow_no) {
      query.flow_no = flow_no;
      this.form.flow_no = flow_no;
    }
    if (channel) {
      query.channel = channel;
      this.form.channel = channel;
    }
    if (payee) {
      query.payee = payee;
      this.form.payee = payee;
    }
    if (uploader) {
      query.uploader = uploader;
      this.form.uploader = uploader;
    }
    if (upload_start_time as any && upload_end_time as any) {
      query.upload_start_time = upload_start_time;
      query.upload_end_time = upload_end_time;
      this.form.upload_start_time = upload_start_time;
      this.form.upload_end_time = upload_end_time;
      this.uploadTime = [moment(upload_start_time as any), moment(upload_end_time as any)];
    }
    if (receipt_start_time as any && receipt_end_time as any) {
      query.receipt_start_time = receipt_start_time;
      query.receipt_end_time = receipt_end_time;
      this.form.receipt_start_time = receipt_start_time;
      this.form.receipt_end_time = receipt_end_time;
      this.receiptTime = [moment(receipt_start_time as any), moment(receipt_end_time as any)];
    }
    console.log(query);
    this.getDyhOrderVoucherList(query);
  }

  onChange() { }

  AddVoucher() {
    this.addVoucherModal.init('payment');
  }

  editVoucher(record: any) {
    this.editVoucherModal.init('edit', record);
  }

  deleVoucher(order: any) {
    let content: any = '该凭证下已关联订单，如果删除，此凭证与所关联订单解除关联关系，是否确定删除？';
    if (order.status === 0) {
      content = '是否确定删除?';
    } else {
      this.$message.error('该凭证下已关联订单，不能删除');
      return;
    }
    this.$confirm({
      title: '提示',
      content,
      onOk: async () => {
        console.log('ok');
        const res = await this.carService.deleteShopOrderDeleteReceipt({ receiptVoucherId: order.id });
        if (res) {
          this.$message.success('删除成功');
          this.search();
        }
      },
      onCancel: () => {
        console.log('cancel');
      },
    });
  }

  lookVoucher(record: any) {
    this.editVoucherModal.init('look', record);
  }

  lookOrder(record: any) {
    if (record.status !== 0) {
      this.correlationOrderDrawer.init(record);
    } else {
      this.$message.error('该凭证下未关联订单');
    }
  }

  mounted() {
    console.log('mounted');
    this.handleSearch();
  }

  search() {
    this.pagination.current = 1;
    this.setQuery();
  }
  resetQuery() {
    this.form = {
      flow_no: '',
      channel: '',
      resource_id: '',
      receive_payment_time: '',
      amount: '',
      payee: '',
      uploader: '',
    };
    this.pagination.current = 1;
    this.uploadTime = [];
    this.receiptTime = [];
    const { current, pageSize } = this.pagination;
    const query: any = {
      page: current,
      pageSize,
    };
    query.timestamp = Math.round(Date.now() / 1000);
    this.$router.push({
      query,
    });
  }

  setQuery() {
    const { current, pageSize } = this.pagination;
    const { flow_no, channel, payee, uploader, upload_start_time, upload_end_time, receipt_start_time, receipt_end_time } = this.form;
    const query: any = {
      page: current,
      pageSize,
    };
    if (flow_no) {
      query.flow_no = flow_no;
    }
    if (channel) {
      query.channel = channel;
    }
    if (payee) {
      query.payee = payee;
    }
    if (uploader) {
      query.uploader = uploader;
    }
    if (upload_start_time as any && upload_end_time as any) {
      query.upload_start_time = upload_start_time;
      query.upload_end_time = upload_end_time;
    }
    if (receipt_start_time as any && receipt_end_time as any) {
      query.receipt_start_time = receipt_start_time;
      query.receipt_end_time = receipt_end_time;
    }
    query.timestamp = Math.round(Date.now() / 1000);
    this.$router.push({
      query,
    });
  }

  onChangePage(page: number) {
    this.pagination.current = page;
    this.setQuery();
  }

  onShowSizeChange(current: number, size: number) {
    this.pagination.current = current;
    this.pagination.pageSize = size;
    this.setQuery();
  }

  async getDyhOrderVoucherList(data: any) {
    const res = await this.voucherService.getDyhOrderVoucherList(data);
    console.log(res);
    if (res) {
      this.pagination.total = res.total;
      this.data = res.list;
    }
  }

  onUploadChange(val: Moment[]) {
    if (!val.length) {
      this.form.contact_time_start = null;
      this.form.contact_time_end = null;
      return;
    }
    this.uploadTime = val;
    this.$set(
      this.form,
      'upload_start_time',
      moment(val[0]).format('YYYY-MM-DD'),
    );
    this.$set(
      this.form,
      'upload_end_time',
      moment(val[1]).format('YYYY-MM-DD'),
    );
  }

  onReceiptChange(val: Moment[]) {
    if (!val.length) {
      this.form.receipt_start_time = null;
      this.form.receipt_end_time = null;
      return;
    }
    this.receiptTime = val;
    this.$set(
      this.form,
      'receipt_start_time',
      moment(val[0]).format('YYYY-MM-DD'),
    );
    this.$set(
      this.form,
      'receipt_end_time',
      moment(val[1]).format('YYYY-MM-DD'),
    );
  }
}
